import Button from "../../../../common/components/atom/Button/Button";

import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget";
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import LinkList from "../../../../features/planBT/components/Link/LinkList";
import { PermissionTooltip, useCapability } from "../../../../features/rbac";

export default function LinkListPage() {

  const {navigate} = useMicroNavigator();
  const canEdit = useCapability('planbt.edit');
  return (
    <div style={{color: 'white'}}>
      <HeaderWidget>Liaisons</HeaderWidget>
      <PermissionTooltip allowed={canEdit}>
        <Button variant={"dark-parimary"} disabled={!canEdit} onClick={() => navigate('create')} iconRightType={"plus"}>Ajouter</Button>
      </PermissionTooltip>
      <div style={{marginTop: 20}}>
      <LinkList.List />
      </div>
    </div>
  )
}
